const asRecord = (value: unknown): Record<string, unknown> | null =>
  value != null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null

export const unwrapDataPayload = <T extends object>(item: unknown): T | null => {
  const row = asRecord(item)
  if (!row) return null

  const nested = asRecord(row.data)
  return (nested ?? row) as T
}

export const extractListRows = (response: unknown): unknown[] => {
  if (response == null) return []
  if (Array.isArray(response)) return response

  const raw = asRecord(response)
  if (!raw) return []

  if (Array.isArray(raw.rows)) return raw.rows
  if (Array.isArray(raw.data)) return raw.data
  if (Array.isArray(raw.Rows)) return raw.Rows

  const nested = asRecord(raw.data)
  if (nested && Array.isArray(nested.rows)) return nested.rows

  return []
}

export const extractListTotal = (response: unknown): number => {
  if (response == null) return 0

  if (Array.isArray(response)) {
    return response.length
  }

  const raw = asRecord(response)
  if (!raw) return 0

  const nested = asRecord(raw.data)
  const candidates = [raw.total, raw.totalRows, raw.Total, nested?.total, nested?.totalRows]

  for (const candidate of candidates) {
    const total = Number(candidate)
    if (!Number.isNaN(total) && total >= 0) {
      return total
    }
  }

  return 0
}
